import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

export const readContactIDsByBoardByQuery = async <
  T extends Record<string, unknown>,
>({
  query,
  boardId,
  data,
  domain,
  headers,
}: FetchRequestArgs & { boardId: string }): Promise<
  ReturnType<typeof fetchRequest>
> => {
  return fetchRequest<T>({
    data,
    domain,
    endpoint: `/contacts/byBoard/${boardId}/IDs/advanced`,
    headers: {
      ...headers,
      'Content-Type': 'text/plain',
    },
    method: HTTPMethod.POST,
    query,
  });
};
